import {MedicationProgramModel} from '@/common/interface/medication.data.model';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LoaderService} from '@services/loader.service';
import {MedicationService} from '@services/medication.service';
import {PlacementService} from '@services/placement.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-active-medication-program',
    templateUrl: './active-medication-program.component.html',
    styleUrl: './active-medication-program.component.scss'
})
export class ActiveMedicationProgramComponent implements OnInit {
    @Input() placementId: number | null = null;
    @Output() close: EventEmitter<void> = new EventEmitter<void>();
    medicationForm: FormGroup;
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();
    public userDetail: any;
    public brandOptions: any;
    public classificationOptions: any[] = [];
    public typeOptions: any[] = [];
    public houses: any[] = [];

    constructor(
        private fb: FormBuilder,
        private placementService: PlacementService,
        private toastr: ToastrService,
        private medicationService: MedicationService,
        private loaderService: LoaderService
    ) {}
    ngOnInit() {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.medicationForm = this.fb.group({
            medications: this.fb.array([]) // Form array for dynamic rows
        });
        this.addMedication();
        this.medicationbrandlist(this.userDetail.id);
        this.getClassificationTypeList();
        this.getApplicationTypeList();
        this.getHouseList();
    }
    get medications(): FormArray {
        return this.medicationForm.get('medications') as FormArray;
    }
    getHouseList() {

    this.placementService
        .getActiveBirdCount(this.placementId || 0)
        .subscribe((result) => {

            this.houses = result;
        });
}
    medicationbrandlist(userId: number) {
        this.medicationService
            .getMedicationListByUserId(userId)
            .subscribe((result) => {
                console.log(result);
                this.brandOptions = result;
            });
    }
    getClassificationTypeList() {
        this.medicationService.getClassificationList().subscribe((result) => {
            // console.log(result);
            this.classificationOptions = result;
        });
    }
    getApplicationTypeList() {
        this.medicationService.getApplicationTypeList().subscribe((result) => {
            console.log(result);
            this.typeOptions = result;
        });
    }
    addMedication() {
        const medicationGroup = this.fb.group({
            id: [0],
            placementId: [this.placementId, Validators.required],
            brandId: ['', Validators.required], // Default to null for placeholder
            typeId: ['', Validators.required], // Default to null for placeholder
            classiFicationId: ['', Validators.required], // Default to null for placeholder
            dose: ['', [Validators.required, Validators.min(0)]],
            duration: ['', [Validators.required, Validators.min(0)]],
            notes: [''],
            applicationDate: ['', Validators.required],
             houseIds: [[], Validators.required],
             houseMedications: this.fb.array([])
        });
        this.medications.push(medicationGroup);
    }

    removeMedication(index: number) {
        this.medications.removeAt(index);
    }

    getHouseMedications(index: number): FormArray {

    return this.medications
        .at(index)
        .get('houseMedications') as FormArray;
    }  
    onHouseSelectionChange(
    event: any,
    index: number
): void {

    const medicationGroup =
        this.medications.at(index);

    const selectedHouseIds =
        event.value || [];

    medicationGroup.patchValue({
        houseIds: selectedHouseIds
    });

    medicationGroup
        .get('houseIds')
        ?.markAsTouched();

    const houseMedications =
        medicationGroup.get(
            'houseMedications'
        ) as FormArray;

    // Clear old rows
    houseMedications.clear();

    if (selectedHouseIds.length === 0) {
        return;
    }

    // Add rows dynamically
    selectedHouseIds.forEach(
        (houseId: number) => {

            const selectedHouse =
                this.houses.find(
                    (x: any) =>
                        x.houseId === houseId
                );

            if (selectedHouse) {

                houseMedications.push(

                    this.fb.group({

                        houseId: [
                            selectedHouse.houseId
                        ],

                        houseName: [
                            {
                                value:
                                    selectedHouse.houseName,
                                disabled: true
                            }
                        ],

                        medicatedBirds: [
                            selectedHouse.activeBirdCount,
                            Validators.required
                        ]
                    })
                );
            }
        }
    );
}


    save() {
        const medicationData: MedicationProgramModel[] =
            this.medicationForm.value.medications;
        console.log(medicationData);

        this.loaderService.showLoader();
        this.isAuthLoading = true;
        // this.markFormGroupTouched(this.bodyWeightForm);
        if (this.medicationForm.valid) {
            const medicationData: MedicationProgramModel[] =
                this.medicationForm.value.medications.map((med: any) => ({
                    ...med,
                    applicationDate: med.applicationDate
                        ? new Date(med.applicationDate).toISOString()
                        : null
                }));
            this.placementService
                .addActivePlacementMedication(medicationData)
                .subscribe({
                    next: (response) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            this.toastr.success(
                                'Medication Added Successfully'
                            );
                            this.dataSaved.emit();
                            this.close.emit();
                        }, 2000);
                    },
                    error: (error) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                            // Handle login error
                            this.toastr.error('Medication Not Added');
                        }, 2000);
                    }
                });
        } else {
            this.medicationForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
        }
        // Send medicationData to backend
    }
    isControlInvalid(controlName: string): boolean {
        const control = this.medicationForm.get(controlName);
        return control?.invalid && (control.touched || control.dirty);
    }
}
